<main
  class="container-fluid tw-flex tw-min-h-96 tw-max-w-2xl tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-py-36"
>
  <img src="/assets/img/icons/svgs/thank-you-paid.svg" alt="thank you" />
  <h1 class="tw-text-center tw-font-body tw-font-bold tw-text-primary">Thank You</h1>
  <div class="tw-space-y-3">
    <p class="tw-text-center tw-text-black">
      Thank you for your application. We will reach out to you for any further clarification.
    </p>
    <p class="tw-text-center tw-text-black">
      Terima kasih atas permohonan anda. Kami akan menghubungi anda untuk sebarang penjelasan
      lanjut.
    </p>
  </div>
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-4 md:tw-flex-row-reverse">
    <a
      class="tw-w-full tw-rounded-md tw-bg-primary tw-py-4 tw-text-center tw-font-semibold tw-text-white hover:tw-text-white"
      routerLink="/pks-bursa"
      routerLinkActive="router-link-active"
    >
      Back to PKS&#64;Bursa
    </a>
  </div>
</main>
